import { Badge, Card, CardContent, CardHeader } from '@forge/common';
import type { RoadmapItem } from '@/api/dashboard';
import { statusStyles } from './statusStyles';

interface RoadmapViewProps {
  items: RoadmapItem[];
  year: number;
}

const RoadmapView = ({ items, year }: RoadmapViewProps) => {
  const yearItems = items.filter((item) => item.year === year);
  const quarters = Array.from(
    new Set(yearItems.map((item) => item.quarter)),
  ).sort((left, right) => left - right);

  return (
    <Card className="border border-gray-200/80 shadow-sm dark:border-gray-800">
      <CardHeader
        title={`Roadmap ${year}`}
        subtitle="Upcoming delivery commitments and sequencing for platform modernization"
      />
      <CardContent top="none">
        <div className="grid gap-x-10 gap-y-8 lg:grid-cols-2">
          {quarters.map((quarter) => {
            const quarterItems = [...yearItems]
              .filter((item) => item.quarter === quarter)
              .sort((left, right) => left.sortOrder - right.sortOrder);

            return (
              <div key={quarter}>
                <div className="mb-2 flex items-center gap-2">
                  <span className="inline-flex items-center rounded-md bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-700 dark:bg-gray-800 dark:text-gray-200">
                    Q{quarter} {year}
                  </span>
                  <span className="text-xs text-color-tertiary">
                    {quarterItems.length} commitments
                  </span>
                </div>
                <ul className="divide-y divide-gray-200/70 dark:divide-gray-800">
                  {quarterItems.map((item) => {
                    const style = statusStyles[item.status];

                    return (
                      <li
                        key={item.id}
                        className="flex items-start gap-3 py-3 first:pt-0 last:pb-0"
                      >
                        <span
                          className={`mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ${style.dotClass}`}
                          aria-hidden
                        />
                        <div className="min-w-0 flex-1">
                          <div className="flex items-start justify-between gap-2">
                            <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                              {item.title}
                            </p>
                            <Badge
                              color={style.badgeColor}
                              type={style.badgeType}
                            >
                              {style.label}
                            </Badge>
                          </div>
                          {item.description ? (
                            <p className="mt-0.5 line-clamp-2 text-sm leading-6 text-color-tertiary">
                              {item.description}
                            </p>
                          ) : undefined}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export type { RoadmapViewProps };
export default RoadmapView;
